import { request } from '@/utils/request';

/**
 * 获取工程档案
 * @param params
 * @returns
 */
export function getProjectList(data) {
  return request('/zlb/budget/prjarch/info/page-my', {
    data,
    method: 'POST',
  });
}

export function getDepartmentProjectList(data) {
  return request('/zlb/budget/prjarch/info/page-unit', {
    data,
    method: 'POST',
  });
}
/**
 * 获取工程档案配置项
 * @param params
 * @returns
 */
export function getProjectOptions(data) {
  return request('/zlb/budget/prjarch/common/option', {
    method: 'POST',
    data,
  });
}
/**
 * 获取经办人信息
 * @param data
 * @returns
 */
export function getWorkersData(data) {
  return request('/zlb/budget/prjarch/operator/search-by-operatorIds', {
    method: 'POST',
    data,
  });
}

/**
 * 获取某个项目经办人列表
 * @param data
 * @returns
 */
export function geProjecttWorkersList(data) {
  return request('/zlb/budget/prjarch/operator/search', {
    method: 'POST',
    data,
  });
}

/**
 * 获取当前登录人详情
 * @returns
 */
export function getOperatorInfo() {
  return request('/api/user/current/operator/displayInfo');
}
/**
 * 嘉兴公安考勤配置获取人员类型列表
 * @returns
 */
export function getJxgaUserType() {
  return request('/zlb/api/office/common/jxga-user-type/get');
}
/**
 * 嘉兴公安加班神钦单获取加班人员类型列表
 * @returns
 */
export function getOvertimeOperatorType(data) {
  return request('/zlb/api/expense/overtime/jxga-user-type/get', {
    method: 'POST',
    data,
  });
}
/**
 * 获取当前登录人详情
 * @returns
 */
export function getProjectDetail(data) {
  return request('/zlb/budget/prjarch/info/detail', {
    method: 'post',
    data,
  });
}

/**
 * 获取文件夹列表
 * @param data
 * @returns
 */
export function getProjectFolders(data) {
  return request('/zlb/budget/prjarch/doc/folder-list', {
    method: 'post',
    data,
  });
}

/**
 * 获取文件列表
 * @param data
 * @returns
 */
export function getProjectFiles(data) {
  return request('/zlb/budget/prjarch/doc/file-list', {
    method: 'post',
    data,
  });
}

/**
 * 删除文件
 * @param data
 * @returns
 */
export function deleteProjectFile(data) {
  return request('/zlb/budget/prjarch/doc/delete', {
    method: 'post',
    data,
  });
}

/**
 * 保存文件
 * @param data
 * @returns
 */
export function saveProjectFile(data) {
  return request('/zlb/budget/prjarch/doc/save', {
    method: 'post',
    data,
  });
}

/**
 * 保存项目
 * @param data
 * @returns
 */
export function saveProject(data) {
  return request('/zlb/budget/prjarch/info/save', {
    method: 'post',
    data,
  });
}

/**
 * 获取项目日志
 * @param data
 * @returns
 */
export function getProjectLog(data) {
  return request('/zlb/budget/prjarch/info/operat-log/page', {
    method: 'post',
    data,
  });
}

/**
 * 删除项目
 * @param data
 * @returns
 */
export function delProject(data) {
  return request('/zlb/budget/prjarch/info/delete', {
    method: 'post',
    data,
  });
}

/**
 * 获取经办人列表
 * @param data
 * @returns
 */
export function getWorkersList(data) {
  return request('/zlb/budget/prjarch/operator/search', {
    method: 'post',
    data,
  });
}

/**
 * 更新经办人列表
 * @param data
 * @returns
 */
export function updateProjectWorkers(data) {
  return request('/zlb/budget/prjarch/operator/save', {
    method: 'post',
    data,
  });
}

export function getOperatorDetail(data) {
  return request('/zlb/budget/prjarch/operator/search-phone', {
    method: 'post',
    data,
  });
}
